
export enum ReportType {
    TRADE_ACTIVITY = "TRADE_ACTIVITY",
    PORTFOLIO_VALUATION = "PORTFOLIO_VALUATION",
    FINANCIAL_TRANSACTIONS = "FINANCIAL_TRANSACTIONS"
}

export const ReportTypes = [
    ReportType.FINANCIAL_TRANSACTIONS,
    ReportType.PORTFOLIO_VALUATION,
    ReportType.TRADE_ACTIVITY
];

export enum ReportFormat {
    PDF = "PDF",
    CSV = "CSV"
}

export function reportFormatExtension(reportFormat: ReportFormat): string {
    switch (reportFormat) {
        case ReportFormat.CSV:
            return ".csv";
        case ReportFormat.PDF:
            return ".pdf";
    }
}
